<template>
    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-7 mb-4 mb-md-0 text-slide-in" :class="{ 'text-slide-in-active': textVisible }">
            <h2>IoT und Echtzeit-Überwachung</h2>
            <p class="mb-4">
              Nutzen Sie IoT-Sensorik um Objekte und Prozesse dauerhaft zu überwachen - bequem aus dem Büro heraus
              oder unterwegs auf dem Smartphone.
              Die automatisierte Datenerfassung inklusive Übermittlung in die Cloud erlaubt es Ihnen, Gefahren
              rechtzeitig zu erkennen und zu reagieren, bevor Schäden auftreten.
              Optimierung Ihrer Betriebsabläufe und Sicherheit für Ihre Kunden dank Echtzeit-Überwachung und KI.
            </p>
          </div>
          <div class="col-md-5 text-center">
            <img
                src="@/assets/iot/realtime_monitoring.jpg"
                alt="Motivation für IoT und Echtzeit-Überwachung"
                class="img-fluid rounded-img shadow-sm top-image"
                :class="{ 'slide-in-active': imageVisible }"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center mb-5">
          <div class="col-md-4 info-point">
            <i class="fas fa-globe fa-3x mb-3 icon"></i>
            <div class="info-point-header">Umfassende Systemüberwachung</div>
            <p>
              Überwachung aus der Ferne, um jederzeit den Zustand von Betriebs- und Kundenobjekten im
              Blick zu behalten. Mittels Dashboards werden die wichtigsten Informationen kompakt bereitgestellt um
              mit einem Blick eine Übersicht über betreute Objekte zu erhalten.
            </p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-tachometer-alt fa-3x mb-3 icon"></i>
            <div class="info-point-header">Mehr Wissen als Andere</div>
            <p>
              Sensorbasierte Systeme erfassen Daten, die sonst nicht zugänglich sind, beispielsweise in Wänden,
              Böden oder im Dach, um Beschädigungen und Gefahren rechtzeitig zu erkennen.
            </p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-rocket fa-3x mb-3 icon"></i>
            <div class="info-point-header">Infrastruktur-Modernisierung <wbr>in Ihrem Betrieb</div>
            <p>
              Digitalisierung und Modernisierung der bestehenden Infrastruktur, um flexible und skalierbare
              Lösung zu schaffen und den Einsatz von künstlicher Intelligenz vorzubereiten.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 dark-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 text-center">
            <img
                src="@/assets/iot/iot_solution.jpg"
                alt="Unsere IoT- und Echtzeit-Überwachungslösung"
                class="img-fluid rounded-img shadow-sm solution-image"
                :class="{ 'slide-in-active': solutionImageVisible }"
            />
          </div>
          <div class="col-md-6 mb-4 mb-md-0 text-slide-up" :class="{ 'text-slide-up-active': solutionTextVisible }">
            <h2>Unsere Lösung</h2>
            <p class="mb-4">
              Wir bauen auf Ihren Betrieb angepasste Lösungen zur Digitalisierung auf Basis von IoT-Technologie.
              Von der Beratung bei der Sensorauswahl, Einrichtung vor Ort, Übertragung von Messwerten, Datenverwaltung und
              automatisierter Auswertung bis zur Erstellung von individuellen Webseiten für Mitarbeiter und Kunden.
              Lassen Sie uns über Ihre Vision zur digitalen Aufwertung Ihrer Dienstleistungen sprechen.
            </p>
            <router-link to="/contact" class="btn btn-primary btn-lg mt-2">
              Wie beraten Sie gerne
              <i class="fas fa-envelope"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="py-5 light-section">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12">
            <h2>Unsere Leistungen</h2>
            <p class="mb-4">
              Digitalisierung hat viele Formen - wir unterstützen Sie bei der Umsetzung ihn Ihrem Betrieb von A bis Z.
            </p>
          </div>
        </div>
        <div class="row text-center mt-4 justify-content-center row-gap-4">
          <div class="col-md-4 info-point">
            <i class="fas fa-network-wired fa-3x mb-3 icon"></i>
            <div class="info-point-header">Erstellung von Systemkonzepten</div>
            <p>Wir planen für Sie die initiale Einrichtung Ihrer Software-Systeme und beraten Sie zu möglichen Varianten
            wie Daten aus Betriebs- oder Kundenobjekten gesammelt werden können. Dabei setzen wir auf etablierte Konzepte,
            haben aber auch neue Lösungen im Blick.</p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-database fa-3x mb-3 icon"></i>
            <div class="info-point-header">Sensordatenmanagement</div>
            <p>Ob in der Cloud oder im eigenen Betrieb - Ihre Daten sind unser Handwerk.
              Wir richten für Sie erprobte Software-Systeme zur Sammlung und Verwaltung aller gesammelten Messwerte ein.
            Natürlich inklusive Sicherungen und unter Einhaltung der geltenden Datenschutzverordnungen.</p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-chart-bar fa-3x mb-3 icon" ></i>
            <div class="info-point-header">Datenauswertung und<wbr> -visualisierung</div>
            <p>Durch regel- oder KI-basierte Erweiterungen extrahieren wir die gewünschten Informationen aus Ihren Daten
              und bereiten diese für Sie auf. Ob betriebs- oder kundenspezifisch, wir kümmern uns darum, dass Sie jederzeit
              schnell und unkompliziert informiert werden.
            </p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-server fa-3x mb-3 icon" ></i>
            <div class="info-point-header">Server-Verwaltung</div>
            <p>Sie haben schon eigene Hardware oder Server? Kein Problem, wir kümmern uns auch darum. Das regelmäßige Einspielen
              von Software-Updates, individuelle Fehleranalyse und die zeitnahe Behebung von Störungen gehören ebenfalls
              zu unserem Angebot. Profitieren Sie von unserer mehrjährigen Erfahrung im Bereich der Systemverwaltung.</p>
          </div>
          <div class="col-md-4 info-point">
            <i class="fas fa-chain fa-3x mb-3 icon"></i>
            <div class="info-point-header">Anbindung von Bestandssensorik</div>
            <p>Falls Sie schon mit Sensorik arbeiten unterstützen wir gerne bei der Anpassung oder Anbindung der
              bestehdenen Systeme an Ihre neuen Lösungen - auch auf Hardware-Ebene.</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted} from 'vue';

export default defineComponent({
  name: 'IoTRealtimeMonitoringPage',
  setup() {
    const textVisible = ref(false);
    const imageVisible = ref(false);
    const solutionTextVisible = ref(false);
    const solutionImageVisible = ref(false);

    onMounted(() => {
      const observerOptions = {
        root: null,
        threshold: 0.1,
      };

      const observerCallback = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains('top-image')) {
              imageVisible.value = true;
            } else if (entry.target.classList.contains('solution-image')) {
              solutionImageVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-in')) {
              textVisible.value = true;
            } else if (entry.target.classList.contains('text-slide-up')) {
              solutionTextVisible.value = true;
            }
          }
        });
      };

      const observer = new IntersectionObserver(observerCallback, observerOptions);

      document.querySelectorAll('.text-slide-in, .top-image, .solution-image, .text-slide-up').forEach(element => {
        observer.observe(element);
      });
    });

    return {textVisible, imageVisible, solutionTextVisible, solutionImageVisible};
  },
});
</script>

<style scoped lang="less">
@import '@/assets/style.less';
@import '@/assets/animations.less';

.top-image {
  margin-top: 2rem;
}

.icon {
  font-size: 4rem;
}

</style>
